// Chips de estado y de evento del ciclo de vida, sobre el `StatusPill` del portal.
import { cn } from '@/lib/cn';
import { StatusPill } from '@/shared/patterns/Pills';
import {
    LIFECYCLE_EVENT_LABEL,
    LIFECYCLE_EVENT_TONE,
    LIFECYCLE_STATUS_LABEL,
    LIFECYCLE_STATUS_TONE,
    type LifecycleEvent,
    type LifecycleStatus,
} from './lifecycleStatus';

/** Un evento fuera del diccionario se pinta con guion: un chip vacío se lee como que no pasó nada. */
const UNKNOWN_EVENT_LABEL = '—';

export function LifecycleStatusBadge({
    status,
    title,
    className,
}: {
    status: LifecycleStatus;
    title?: string;
    className?: string;
}) {
    return (
        <StatusPill
            tone={LIFECYCLE_STATUS_TONE[status]}
            title={title}
            className={cn(status === 'DRAFT' && 'border-dashed', className)}
        >
            {LIFECYCLE_STATUS_LABEL[status]}
        </StatusPill>
    );
}

/** Punto de aviso junto al badge; el texto va solo para lector de pantalla. */
export function LifecyclePendingMark({ label }: { label: string }) {
    return (
        <>
            <span aria-hidden className="size-1.5 flex-none rounded-full bg-warning" />
            <span className="sr-only">{label}</span>
        </>
    );
}

export function LifecycleEventBadge({
    event,
    label,
}: {
    /** `null` es un evento que el diccionario no conoce. */
    event: LifecycleEvent | null;
    /** Etiqueta propia del dominio cuando el evento no está en el diccionario. */
    label?: string;
}) {
    if (event === null) {
        return <StatusPill tone="neutral">{label ?? UNKNOWN_EVENT_LABEL}</StatusPill>;
    }
    return (
        <StatusPill tone={LIFECYCLE_EVENT_TONE[event]}>{LIFECYCLE_EVENT_LABEL[event]}</StatusPill>
    );
}
